module.exports = __webpack_public_path__ + "img/VNM.04eeaf26.svg";